import { render, staticRenderFns } from "./FullWidthBanner.vue?vue&type=template&id=13d21608&scoped=true&lang=pug&"
import script from "./FullWidthBanner.vue?vue&type=script&lang=js&"
export * from "./FullWidthBanner.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthBanner.vue?vue&type=style&index=0&id=13d21608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d21608",
  null
  
)

export default component.exports